import { render } from "./edit-waitlist.vue?vue&type=template&id=d31cca4a&scoped=true"
import script from "./edit-waitlist.vue?vue&type=script&lang=js"
export * from "./edit-waitlist.vue?vue&type=script&lang=js"

import "./edit-waitlist.vue?vue&type=style&index=0&id=d31cca4a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d31cca4a"]])

export default __exports__